var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    zoomAndPan: "magnify",
    viewBox: "0 0 52.5 52.499999",
    height: 70,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "29d95296cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.078125 0 L 52.003906 0 L 52.003906 44 L 2.078125 44 Z M 2.078125 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#29d95296cc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M 17.136719 22.195312 C 26.941406 12.390625 36.746094 2.585938 46.550781 -7.222656 C 47.800781 -5.96875 50.242188 -6.160156 51.492188 -4.90625 C 52.660156 -3.738281 52.636719 -1.132812 53.804688 0.0351562 L 24.390625 29.449219 C 25.574219 33.246094 24.664062 37.558594 21.65625 40.566406 C 18.613281 43.605469 14.246094 44.503906 10.417969 43.265625 L 16.816406 36.863281 L 15.8125 31.023438 L 9.71875 29.765625 L 3.320312 36.167969 C 2.078125 32.339844 2.980469 27.96875 6.019531 24.929688 C 9.027344 21.921875 13.335938 21.011719 17.136719 22.195312 Z M 24.230469 24.667969 L 21.917969 22.355469 L 46.996094 -2.726562 L 49.308594 -0.410156 Z M 24.230469 24.667969 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.7651dfa6b1234a5ddb4eb5f3cebcc812.svg";
export { ForwardRef as ReactComponent };